import { FormattedMessage, IntlShape, useIntl } from 'react-intl';
import { Access, MeetingStatus } from '../api/meetings.dao';
import { EventAccess } from '../api/events.dao';
import React from 'react';
import { AttendeeLinkType } from '../api/attendees.dao';
import { PASSPORT_URL_YEAR_FORMATS } from '../api/blueprints/blueprint.types';

export const meetingStatusOptions = () => {
    const intl = useIntl();

    return [
        {
            value: MeetingStatus.Scheduled,
            label: intl.formatMessage({ id: 'oe.common.scheduled', defaultMessage: 'Scheduled', description: 'Option label' })
        },
        {
            value: MeetingStatus.Cancelled,
            label: intl.formatMessage({ id: 'oe.common.cancelled', defaultMessage: 'Cancelled', description: 'Option label' })
        },
        {
            value: MeetingStatus.Removed,
            label: intl.formatMessage({ id: 'oe.common.removed', defaultMessage: 'Removed', description: 'Option label' })
        }
    ];
};

export const meetingAccessOptions = () => {
    const intl = useIntl();

    return [
        {
            value: Access.Closed,
            label: intl.formatMessage({ id: 'oe.common.closed', defaultMessage: 'Closed', description: 'Option label' })
        },
        {
            value: Access.Open,
            label: intl.formatMessage({ id: 'oe.common.open', defaultMessage: 'Open', description: 'Button label text' })
        },
        {
            value: Access.Plenary,
            label: intl.formatMessage({ id: 'oe.common.plenary', defaultMessage: 'Plenary', description: 'Option label' })
        },
        {
            value: Access.Bookable,
            label: intl.formatMessage({ id: 'oe.common.bookable', defaultMessage: 'Bookable', description: 'Option label' })
        }
    ];
};

export const eventAccessOptions = () => {
    const intl = useIntl();

    return [
        {
            value: EventAccess.Restricted,
            label: intl.formatMessage({
                id: 'oe.eventAccess.Restricted',
                description: 'Label text',
                defaultMessage: 'Restricted',
            })
        },
        {
            value: EventAccess.Open,
            label: intl.formatMessage({
                id: 'oe.eventAccess.open',
                description: 'Label text',
                defaultMessage: 'Open',
            })
        }
    ];
};

export const attendeeLinkTypeOptions = (intl: IntlShape) => {
    return [
        {
            value: AttendeeLinkType.MEETING_LINK_WITH_EMBEDDED_PASSCODE,
            label: intl.formatMessage({
                id: 'oe.attendeeLink.oeMeetingLinkWithEmbeddedPasscode',
                description: 'Label text',
                defaultMessage: 'OE Meeting Link with Embedded Passcode'
            })
        },
        {
            value: AttendeeLinkType.PASSPORT_LINK,
            label: intl.formatMessage({
                id: 'oe.attendeeLink.oePassportLink',
                description: 'Label text',
                defaultMessage: 'OE Passport Link'
            })
        }
    ];
};

export const passportURLFormatOptions = (intl: IntlShape) => {
    return [
        {
            value: PASSPORT_URL_YEAR_FORMATS.SHORT_YEAR_FORMAT,
            label: intl.formatMessage({
                id: 'oe.passportURLFormat.shortYearFormat',
                description: 'Label text',
                defaultMessage: 'Event Name & MMM-YY'
            })
        },
        {
            value: PASSPORT_URL_YEAR_FORMATS.LONG_YEAR_FORMAT,
            label: intl.formatMessage({
                id: 'oe.passportURLFormat.longYearFormat',
                description: 'Label text',
                defaultMessage: 'Event Name & MMM-YYYY'
            })
        }
    ];
};

export const autoRegEnabledSetting: React.ReactElement = <FormattedMessage
    id='oe.blueprints.connections.settings.autoReg'
    defaultMessage='Auto Reg'
    description='Label text'
/>;

export const autoSyncEnabledSetting: React.ReactElement = <FormattedMessage
    id='oe.blueprints.connections.settings.autoSync'
    defaultMessage='Auto Sync'
    description='Label text'
/>;

export const passportReplayEnabledSetting: React.ReactElement = <FormattedMessage
    id='oe.blueprints.connections.settings.passportReplay'
    defaultMessage='Replay'
    description='Label text'
/>;
